import React from 'react';
import Blog from './Blog.jsx';
import Gallery from './Gallery.jsx';
import FAQ from './FAQ.jsx';
import SEO from '../Components/SEO';

function Resources() {
    return (
        <div>
            <SEO 
              title="Resources, Blog & Gallery" 
              description="Explore our blogs, scrap material gallery, and frequently asked questions about scrap metal recycling and industrial metal rates."
              keywords="scrap recycling resources, scrap blog, scrap gallery, FAQ scrap metal recycling"
            />
            <Blog />
            <Gallery />
            <FAQ />
        </div>
    )
}
export default Resources;